import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { ProtectedLayout } from '../components/ProtectedLayout';
import Register from '../modules/Auth/Register';
import Welcome from '../modules/Welcome';
import Profile from '../modules/Profile';
import Account from '../modules/Profile/Account';
import Meetings from '../modules/Meetings';
import NewMeeting from '../modules/Meetings/NewMeeting';
// import ScheduleMeeting from '../modules/Meetings/ScheduleMeeting'; // Agenda integrada ao NewMeeting
import ListMeetings from '../modules/Meetings/ListMeetings';
import EditMeeting from '../modules/Meetings/EditMeeting';
import Search from '../modules/Search';
import MeetingDetails from '../modules/Search/MeetingDetails';
import MeetingPayment from '../modules/Search/MeetingPayment';
import Login from '../modules/Auth/Login';
import { ProtectedBackoffice } from '../components/ProtectedBackoffice';
import Dashboard from '../modules/Dashboard';
import Users from '../modules/Users';
import UsersList from '../modules/Users/screens/UsersList';
import Schedule from '../modules/Schedule';
import ScheduledDetails from '../modules/Schedule/ScheduledDetails';
import ScheduledList from '../modules/Schedule/ScheduledList';
import ScheduledCall from '../modules/Schedule/ScheduledCall';
import MeetingSearch from '../modules/Search/MeetingSearch';
import Sales from '../modules/Sales';
import SalesList from '../modules/Sales/screens/SalesList';
import Settings from '../modules/Settings/screens';
import ScheduledPlayer from '../modules/Schedule/ScheduledPlayer';
import Receiver from '../modules/Profile/Receiver';
import SalesMeeting from '../modules/Meetings/SalesMeeting';
import Host from '../modules/Host';
import LostPass from '../modules/Auth/LostPass';
import ResetPassword from '../modules/Auth/ResetPassword';
import GuardianConsent from '../modules/Auth/GuardianConsent';
import Password from '../modules/Profile/Password';
import ReceiverStatus from '../modules/Profile/ReceiverStatus';
import NotFound from '../modules/Auth/NotFound';
import Calendar from '../modules/Calendar';
import MyProfile from '../modules/MyProfile';
import FindMeetings from '../modules/FindMeetings/Index';
import Acompanhando from '../modules/FindMeetings/Acompanhando';
import FindMeetingsLayout from '../modules/FindMeetings/Layout';
import LiveMeetings from '../modules/FindMeetings/LiveMeetings';
import SpectatorPlayer from '../modules/FindMeetings/SpectatorPlayer';
import Terms from '../modules/Terms';
import Privacy from '../modules/Privacy';
import Glossary from '../modules/Glossary';
import Policies from '../modules/Policies';
import CompraEPagamento from '../modules/Policies/CompraEPagamento';
import UsoResponsavel from '../modules/Policies/UsoResponsavel';
import Seguranca from '../modules/Policies/Seguranca';
import ChatBot from '../modules/ChatBot';
import LiveChat from '../modules/LiveChat';
import Support from '../modules/Support';
import SupportQueue from '../modules/SupportQueue';
import MeetingChat from '../modules/MeetingChat';

export default () => {
    return (
        <Routes>
            <Route index path="/" element={<Welcome />} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<NotFound />} />

            <Route path="criar-conta" element={<Register />} />
            <Route path="recuperar-senha" element={<LostPass />} />
            <Route path="redefinir-senha" element={<ResetPassword />} />
            {/* Quem abre esta tela e o responsavel pelo adolescente, que nao
                tem conta: publica, identificada so pelo token do e-mail. */}
            <Route path="autorizacao/:token" element={<GuardianConsent />} />
            <Route path="termos" element={<Terms />} />
            <Route path="privacidade" element={<Privacy />} />
            {/* Caminho impresso nos Termos e na Politica de Compra e Pagamento:
                o endereco /glossario ja circula nos documentos, entao a rota
                precisa existir exatamente assim. */}
            <Route path="glossario" element={<Glossary />} />
            {/* Central: e para ca que rodape, header, cadastro, login e chatbot
                apontam. Sao seis documentos, e mandar o usuario direto aos
                Termos deixava os outros sem porta de entrada. */}
            <Route path="politicas">
                <Route index element={<Policies />} />
                <Route path="compra-e-pagamento" element={<CompraEPagamento />} />
                <Route path="uso-responsavel" element={<UsoResponsavel />} />
                <Route path="seguranca" element={<Seguranca />} />
            </Route>

            <Route path="backoffice" element={<ProtectedBackoffice />}>
                <Route index element={<Dashboard />} />
                <Route path="usuarios" element={<Users />}>
                    <Route index element={<UsersList />} />
                </Route>
                <Route path="vendas" element={<Sales />}>
                    <Route index element={<SalesList />} />
                </Route>
                <Route path="configuracoes" element={<Settings />} />
                <Route path="livechat" element={<LiveChat />} />
                <Route path="atendimento" element={<SupportQueue />} />
            </Route>

            <Route path="chat-bot" element={<ChatBot />} />

            <Route element={<ProtectedLayout />}>
                <Route path="meuperfil" element={<MyProfile />} />
                <Route path="calendario" element={<Calendar />} />
                {/* Canal interno de atendimento (Termos 1.11) */}
                <Route path="atendimento" element={<Support />} />
                {/* Canal interno entre anfitriao e conviva (Termos 1.11). As
                    duas rotas caem no mesmo componente: a lista e a conversa
                    dividem a tela no desktop e se alternam no celular. */}
                <Route path="conversas" element={<MeetingChat />} />
                <Route path="conversas/:id" element={<MeetingChat />} />
                {/* Lista de anfitrioes acompanhados: e por ela que o conviva
                    deixa de acompanhar sem precisar achar cada perfil */}
                <Route path="acompanhando" element={<Acompanhando />} />
                <Route path="boas-vindas" element={<Welcome />} />
                <Route path="conta" element={<Account />} />
                <Route path="perfil" element={<Profile />} />
                <Route path="recebimento" element={<Receiver />} />
                <Route path="status" element={<ReceiverStatus />} />
                <Route path="mudar-senha" element={<Password />} />
                <Route path="lista" element={<FindMeetingsLayout />}>
                    <Route index element={<FindMeetings />} />
                    <Route path="ao-vivo" element={<LiveMeetings />} />
                    <Route path="ao-vivo/:schedule_id" element={<SpectatorPlayer />} />
                </Route>

                <Route path="meus-encontros" element={<Meetings />}>
                    <Route index element={<ListMeetings />} />
                    <Route path="novo" element={<NewMeeting />} />
                    <Route path=":id/detalhes" element={<EditMeeting />} />
                    <Route path=":id/horarios" element={<SalesMeeting />} />
                </Route>

                <Route path="encontros" element={<Schedule />}>
                    <Route index element={<ScheduledList />} />
                    <Route path=":id/detalhes" element={<ScheduledDetails />} />
                    <Route path=":id/chamada" element={<ScheduledCall />} />
                    <Route path=":id/player" element={<ScheduledPlayer />} />
                </Route>

                <Route path="anfitriao" element={<Outlet />}>
                    <Route index path=":username" element={<Host />} />
                </Route>

                <Route path="encontrar" element={<Search />}>
                    <Route index element={<MeetingSearch />} />
                    <Route path=":id/detalhes" element={<MeetingDetails />} />
                    <Route path=":id/pagamento" element={<MeetingPayment />} />
                </Route>
            </Route>

        </Routes>
    );
};
